import { render, staticRenderFns } from "./fork_sync_conflicts_modal.vue.js?vue&type=template&id=3ab752b4&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./fork_sync_conflicts_modal.vue?vue&type=template&id=3ab752b4&vue3"
import script from "./fork_sync_conflicts_modal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./fork_sync_conflicts_modal.vue?vue&type=script&lang=js&vue3"
export * from "./fork_sync_conflicts_modal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./fork_sync_conflicts_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports